import { render, staticRenderFns } from "./tableSystem.vue?vue&type=template&id=d551775c&scoped=true"
import script from "./tableSystem.vue?vue&type=script&lang=js"
export * from "./tableSystem.vue?vue&type=script&lang=js"
import style0 from "./tableSystem.vue?vue&type=style&index=0&id=d551775c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d551775c",
  null
  
)

export default component.exports